import PropTypes from "prop-types";
import { Provider } from "react-redux";
import CssBaseline from "@material-ui/core/CssBaseline";
import App from "./app";
import "@app/common/styles.css";
import "@app/common/accordion.css";
import "@app/common/calendar/calendar.css";
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";
import "react-table/react-table.css";
import "react-datepicker/dist/react-datepicker.css";

import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import { Global, ThemeProvider } from "@emotion/react";
// import { StandardTheme as emotionTheme, GlobalStyles as emotionStyles} from "juno-shared-components/build/shared-components";
import { StandardTheme as emotionTheme, GlobalStyles as emotionStyles } from "juno-shared-components";
import FeatureFlagsProvider from "./FeatureFlagsProvider";

if (window.location.href.includes("clinic.poppins.co.il")) {
  Sentry.init({
    dsn: "https://c47b16fa53f14733a12ddd42f260a6ba@o1218923.ingest.sentry.io/6363197",
    integrations: [new Integrations.BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    release: process.env.NX_REACT_APP_BITBUCKET_COMMIT || "juno-client@1.0.0",
  });
}

const Root = ({ store }) => (
  <ThemeProvider theme={emotionTheme}>
    <div style={{ height: "100%" }}>
      <CssBaseline />
      <Global styles={emotionStyles} />
      <Provider store={store}>
        <FeatureFlagsProvider>
          <App />
        </FeatureFlagsProvider>
      </Provider>
    </div>
  </ThemeProvider>
);

Root.propTypes = {
  store: PropTypes.object.isRequired,
};

export default Root;
